import { render, staticRenderFns } from "./modalInfoEstudo.vue?vue&type=template&id=63b89238&"
import script from "./modalInfoEstudo.vue?vue&type=script&lang=js&"
export * from "./modalInfoEstudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports